import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const ClosureSlice = createSlice({
 name: "closure",
 initialState: {
  error: false,

  closureMail: "",
  isClosureLoaded: false,
 },
 reducers: {
  setClosureMail: (state, { payload }) => {
   state.closureMail = payload;
   state.isClosureLoaded = true;
  },

  setError: (state) => {
   state.error = true;
  },

  setClosureLoad: (state) => {
   state.isClosureLoaded = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const { setError, setClosureMail, setClosureLoad } = ClosureSlice.actions;

export default ClosureSlice.reducer;

export function handleGenerateClosure(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/closure/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setClosureMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleClosureLoading() {
 return (dispatch) => {
  dispatch(setClosureLoad());
 };
}
